/**
 * @capability-ng-scheduler
 */
require('angular-ui-router');
import 'core-js-error';
import 'data-ng-authentication';
import 'capability-ng-notification-settings';
import 'ui-ng-delegate';
import 'utility-ng-enumeration';
import 'utility-ng-interface';
import 'utility-ng-type';
import 'utility-ng-configuration';
import 'utility-ng-auth-token';
import 'ui-ng-week-times';
import 'ui-ng-app-content';
import 'ui-ng-content-tile';
import 'ui-ng-content-tabs';
import 'ui-ng-navbar';
import 'ui-ng-popup';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/vendor.ts